module.exports = __webpack_public_path__ + "img/logo_w.840cad61.png";